import React, { Fragment, useState } from 'react';
import { Button }from '@cmsgov/design-system';

import { FormattedMessage } from 'react-intl';

// Components

import Form from '@lib/wrappers/Form';
import ModalHeader from '@common-components/headers/ModalHeader';
import UniversalInput from '@lib/wrappers/UniversalInput';

// Constants

import { INPUT_TYPES } from '@constants/inputs/inputTypes';
import { VALIDATION_TYPES } from '@constants/inputs/validationTypes';



const ExtraModal = props => {

    const {
        actions: {
            hideModal
        },
        bottomAnchors: [
            anchor_1,
        ],
        boundAnchor,
        methods,
        modalHeaderProps
    } = props;

    const [ val, toggleVal ] = useState('');

    const handleChange = (...args) => {
        const [ , , , [ , value ] ] = args;
        toggleVal(value);
    };

    return (
        <Fragment>
            <ModalHeader  { ...modalHeaderProps } />
            <div id = 'extraModal' >
                <Form { ...{ formName: 'extraForm' } } >
                    <UniversalInput
                        label={{
                            text: 'ssap.input.label.extra',
                            isLabelRequired: false,
                        }}
                        inputData={{
                            isInputRequired: true,
                            type: INPUT_TYPES.REGULAR_INPUT,
                            name: 'extra',
                            value: val,
                            placeholder: 'ssap.input.placeholder.provide_something',
                            validationType: VALIDATION_TYPES.NAME,
                            currentData: {},
                            fields: []

                        }}
                        inputActions={{
                            onFieldChange: handleChange
                        }}
                    />
                </Form>
            </div>
            <Button
                className='modal-extra-btn usa-button-secondary'
                inputRef={boundAnchor(anchor_1)}
                onClick={() => {
                    methods.extraForm.onFormSubmitForValidationOnly([() => hideModal()]);
                }}
            >
                <FormattedMessage id='button.save'/>
            </Button>
        </Fragment>
    );
};

export default ExtraModal;
